module.exports = __webpack_public_path__ + "img/error-icon.2ecd743c.png";